module.exports = __webpack_public_path__ + "assets/090831cca59e879a206a5fb616ca923b.png";